import React from 'react'
import { useStateAuthContext, useStateHostContext } from '../context';
import { BeatLoader } from 'react-spinners';
import { error } from 'jquery';
import { Tab, Tabs as BootstrapTabs } from 'react-bootstrap';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';

const Admin_kendaraan_statistik = () => {
  window.document.title = "Kendaraan"
  const { HOST } = useStateHostContext();
  const { STATE_AUTH } = useStateAuthContext();
  const [loading, set_loading] = React.useState(false)
  const [data_total, set_data_total] = React.useState({})

  const ambilDataKendaraan = React.useCallback(async () => {
    set_loading(true)
    try {
      const request = await fetch(HOST + '/admin/kendaraan/statistik', {
        method: 'GET',
        headers: {
          'REST-TOKEN': STATE_AUTH.token
        }
      })

      const response = await request.json()

      if (request.ok) {
        if (response.s) {
          set_data_total(response.d);
          set_loading(false)
        }
      } else {
        throw new Error(response.m)
      }
    } catch (err) {
      error({ msg: err.message })
      set_loading(false)
    }

  }, [HOST, STATE_AUTH])

  React.useEffect(() => {
    ambilDataKendaraan()
  }, [ambilDataKendaraan])

  const cek_total = Object.keys(data_total).length === 0

  console.log(data_total);

  return (
    <main>
      <div className="container-fluid mt-3">
        <div className="row mt-3">
          <div className="col-md-12">
            <h3><strong><i className='fas fa-car'></i> STATISTIK KENDARAAN</strong></h3>
          </div>
        </div>
        <hr />
        <div className="row mt-2">
          {
            !loading
              ?
              !cek_total
                ?
                <BootstrapTabs defaultActiveKey="table" id="statistik-tabs" className="mb-3">
                  <Tab eventKey="table" title="Tabel">
                    <div className="row">
                      <div className="col-md-12">
                        <h5>Berdasarkan Jenis Kendaraan</h5>
                        <div className='table-responsive'>
                          <table className='tb-daftar-dinas mt-1'>
                            <thead>
                              <tr>
                                <th width="20%">Jenis Kendaraan</th>
                                <th>Jumlah</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td className='td-daftar-dinas'>Motor</td>
                                <td className='td-daftar-dinas'>{data_total.jenis_kendaraan?.motor}</td>
                              </tr>
                              <tr>
                                <td className='td-daftar-dinas'>Mobil</td>
                                <td className='td-daftar-dinas'>{data_total.jenis_kendaraan?.mobil}</td>
                              </tr>
                              <tr>
                                <td className='td-daftar-dinas'>Alat Berat</td>
                                <td className='td-daftar-dinas'>{data_total.jenis_kendaraan?.alat_berat}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="col-md-12 mt-3">
                        <h5>Berdasarkan Status Kondisi</h5>
                        <div className='table-responsive'>
                          <table className='tb-daftar-dinas mt-1'>
                            <thead>
                              <tr>
                                <th width="20%">Kondisi</th>
                                <th>Jumlah</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td className='td-daftar-dinas'>Baik</td>
                                <td className='td-daftar-dinas'>{data_total.status_kondisi?.baik}</td>
                              </tr>
                              <tr>
                                <td className='td-daftar-dinas'>Rusak Ringan</td>
                                <td className='td-daftar-dinas'>{data_total.status_kondisi?.rusak_ringan}</td>
                              </tr>
                              <tr>
                                <td className='td-daftar-dinas'>Rusak Berat</td>
                                <td className='td-daftar-dinas'>{data_total.status_kondisi?.rusak_berat}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="col-md-12 mt-3">
                        <h5>Berdasarkan Status Barang</h5>
                        <div className='table-responsive'>
                          <table className='tb-daftar-dinas mt-1'>
                            <thead>
                              <tr>
                                <th width="20%">Barang</th>
                                <th>Jumlah</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td className='td-daftar-dinas'>Tersedia</td>
                                <td className='td-daftar-dinas'>{data_total.status_barang?.tersedia}</td>
                              </tr>
                              <tr>
                                <td className='td-daftar-dinas'>Hilang</td>
                                <td className='td-daftar-dinas'>{data_total.status_barang?.hilang}</td>
                              </tr>
                              <tr>
                                <td className='td-daftar-dinas'>Pinjam Pakai</td>
                                <td className='td-daftar-dinas'>{data_total.status_barang?.pinjam_pakai}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="col-md-12 mt-3">
                        <h5>Berdasarkan Status Lelang</h5>
                        <div className='table-responsive'>
                          <table className='tb-daftar-dinas mt-1'>
                            <thead>
                              <tr>
                                <th width="20%">Status Lelang</th>
                                <th>Jumlah</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td className='td-daftar-dinas'>Penilaian</td>
                                <td className='td-daftar-dinas'>{data_total.status_lelang?.penilaian}</td>
                              </tr>
                              <tr>
                                <td className='td-daftar-dinas'>Lelang</td>
                                <td className='td-daftar-dinas'>{data_total.status_lelang?.lelang}</td>
                              </tr>
                              <tr>
                                <td className='td-daftar-dinas'>Selesai</td>
                                <td className='td-daftar-dinas'>{data_total.status_lelang?.selesai}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="col-md-12 mt-3">
                        <h5>Berdasarkan Kendaraan Dihapus</h5>
                        <div className='table-responsive'>
                          <table className='tb-daftar-dinas mt-1'>
                            <thead>
                              <tr>
                                <th width="20%">Status</th>
                                <th>Jumlah</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td className='td-daftar-dinas'>Dihapus</td>
                                <td className='td-daftar-dinas'>{data_total.kendaraan_dihapus}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="col-md-12 mt-3">
                        <h5>Berdasarkan Kendaraan Mutasi</h5>
                        <div className='table-responsive'>
                          <table className='tb-daftar-dinas mt-1'>
                            <thead>
                              <tr>
                                <th width="20%">Status</th>
                                <th>Jumlah</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td className='td-daftar-dinas'>Mutasi</td>
                                <td className='td-daftar-dinas'>{data_total.kendaraan_mutasi}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="col-md-12 mt-3">
                        <h5>Total Kendaraan: <span className='fw-bold'>{data_total.total_kendaraan}</span></h5>
                      </div>
                    </div>
                  </Tab>
                  <Tab eventKey="chart" title="Grafik">
                    <div className="row">
                      <div className="col-md-6 mb-4">
                        <div className="card shadow">
                          <div className="card-body">
                            <h5 className="card-title">Berdasarkan Jenis Kendaraan</h5>
                            <div style={{ width: '100%', height: 300 }}>
                              <ResponsiveContainer width="100%" height="100%">
                                <BarChart
                                  data={[
                                    { name: 'Motor', jumlah: data_total.jenis_kendaraan?.motor || 0 },
                                    { name: 'Mobil', jumlah: data_total.jenis_kendaraan?.mobil || 0 },
                                    { name: 'Alat Berat', jumlah: data_total.jenis_kendaraan?.alat_berat || 0 }
                                  ]}
                                  margin={{
                                    top: 5,
                                    right: 30,
                                    left: 20,
                                    bottom: 5,
                                  }}
                                >
                                  <CartesianGrid strokeDasharray="3 3" />
                                  <XAxis dataKey="name" />
                                  <YAxis />
                                  <Tooltip />
                                  <Legend />
                                  <Bar dataKey="jumlah" name="Jumlah Kendaraan" fill="#8884d8" />
                                </BarChart>
                              </ResponsiveContainer>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-4">
                        <div className="card shadow">
                          <div className="card-body">
                            <h5 className="card-title">Berdasarkan Status Kondisi</h5>
                            <div style={{ width: '100%', height: 300 }}>
                              <ResponsiveContainer width="100%" height="100%">
                                <BarChart
                                  data={[
                                    { name: 'Baik', jumlah: data_total.status_kondisi?.baik || 0 },
                                    { name: 'Rusak Ringan', jumlah: data_total.status_kondisi?.rusak_ringan || 0 },
                                    { name: 'Rusak Berat', jumlah: data_total.status_kondisi?.rusak_berat || 0 }
                                  ]}
                                  margin={{
                                    top: 5,
                                    right: 30,
                                    left: 20,
                                    bottom: 5,
                                  }}
                                >
                                  <CartesianGrid strokeDasharray="3 3" />
                                  <XAxis dataKey="name" />
                                  <YAxis />
                                  <Tooltip />
                                  <Legend />
                                  <Bar dataKey="jumlah" name="Jumlah Kendaraan" fill="#82ca9d" />
                                </BarChart>
                              </ResponsiveContainer>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-4">
                        <div className="card shadow">
                          <div className="card-body">
                            <h5 className="card-title">Berdasarkan Status Barang</h5>
                            <div style={{ width: '100%', height: 300 }}>
                              <ResponsiveContainer width="100%" height="100%">
                                <PieChart>
                                  <Pie
                                    data={[
                                      { name: 'Tersedia', value: data_total.status_barang?.tersedia || 0 },
                                      { name: 'Hilang', value: data_total.status_barang?.hilang || 0 },
                                      { name: 'Pinjam Pakai', value: data_total.status_barang?.pinjam_pakai || 0 }
                                    ]}
                                    cx="50%"
                                    cy="50%"
                                    labelLine={true}
                                    label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                                    outerRadius={80}
                                    fill="#8884d8"
                                    dataKey="value"
                                  >
                                    {[
                                      { name: 'Tersedia', value: data_total.status_barang?.tersedia || 0, color: '#0088FE' },
                                      { name: 'Hilang', value: data_total.status_barang?.hilang || 0, color: '#00C49F' },
                                      { name: 'Pinjam Pakai', value: data_total.status_barang?.pinjam_pakai || 0, color: '#FFBB28' }
                                    ].map((entry, index) => (
                                      <Cell key={`cell-${index}`} fill={entry.color} />
                                    ))}
                                  </Pie>
                                  <Tooltip />
                                  <Legend />
                                </PieChart>
                              </ResponsiveContainer>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-4">
                        <div className="card shadow">
                          <div className="card-body">
                            <h5 className="card-title">Berdasarkan Status Lelang</h5>
                            <div style={{ width: '100%', height: 300 }}>
                              <ResponsiveContainer width="100%" height="100%">
                                <PieChart>
                                  <Pie
                                    data={[
                                      { name: 'Penilaian', value: data_total.status_lelang?.penilaian || 0 },
                                      { name: 'Lelang', value: data_total.status_lelang?.lelang || 0 },
                                      { name: 'Selesai', value: data_total.status_lelang?.selesai || 0 }
                                    ]}
                                    cx="50%"
                                    cy="50%"
                                    labelLine={true}
                                    label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                                    outerRadius={80}
                                    fill="#8884d8"
                                    dataKey="value"
                                  >
                                    {[
                                      { name: 'Penilaian', value: data_total.status_lelang?.penilaian || 0, color: '#FF8042' },
                                      { name: 'Lelang', value: data_total.status_lelang?.lelang || 0, color: '#0088FE' },
                                      { name: 'Selesai', value: data_total.status_lelang?.selesai || 0, color: '#00C49F' }
                                    ].map((entry, index) => (
                                      <Cell key={`cell-${index}`} fill={entry.color} />
                                    ))}
                                  </Pie>
                                  <Tooltip />
                                  <Legend />
                                </PieChart>
                              </ResponsiveContainer>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-4">
                        <div className="card shadow">
                          <div className="card-body">
                            <h5 className="card-title">Kendaraan Dihapus dan Mutasi</h5>
                            <div style={{ width: '100%', height: 300 }}>
                              <ResponsiveContainer width="100%" height="100%">
                                <BarChart
                                  data={[
                                    { name: 'Dihapus', jumlah: data_total.kendaraan_dihapus || 0 },
                                    { name: 'Mutasi', jumlah: data_total.kendaraan_mutasi || 0 }
                                  ]}
                                  margin={{
                                    top: 5,
                                    right: 30,
                                    left: 20,
                                    bottom: 5,
                                  }}
                                >
                                  <CartesianGrid strokeDasharray="3 3" />
                                  <XAxis dataKey="name" />
                                  <YAxis />
                                  <Tooltip />
                                  <Legend />
                                  <Bar dataKey="jumlah" name="Jumlah Kendaraan" fill="#ff7300" />
                                </BarChart>
                              </ResponsiveContainer>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-4">
                        <div className="card shadow text-center">
                          <div className="card-body d-flex flex-column justify-content-center">
                            <h5 className="card-title">Total Kendaraan</h5>
                            <h3 className="fw-bold">{data_total.total_kendaraan}</h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tab>
                </BootstrapTabs>
                :
                ''
              :
              <div className='col-md-12 text-center'>
                <BeatLoader />
              </div>

          }

        </div>
      </div>
    </main>
  )
}

export default Admin_kendaraan_statistik